import React, { useState, useEffect } from 'react'
import './userlogin.scss'
import { useHistory } from 'react-router-dom'


const Login = () => {

    const stored_email = sessionStorage.getItem('email')
    const stored_pw = sessionStorage.getItem('pw')
    const history = useHistory();
    const [loading, setLoading] = useState(false)
    const [resetPassword, setResetPassword] = useState(false)
    const [error, setError] = useState(false)
    const [notFoundError,setNotFoundError] = useState()
    const [emailError, setEmailError] = useState('')
    const [email, setEmail] = useState(stored_email ? stored_email : '')
    const [password, setPassword] = useState(stored_pw ? stored_pw :'');
    const [passwordError, setPasswordError] = useState("");
    const [rememberme, setRememberme] = useState(stored_email && stored_pw ? true : false)

    const [showNoValidEmail, setShowNoValidEmail] = useState()
    const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;

    const validateEmail = (e) => {
        if (e.target?.value && e.target.value.match(isValidEmail)) {
            setShowNoValidEmail(false);
            setEmail(e.target.value)
           
        }
    }

  function handleSubmit  ()  {
        //event.preventDefault()
      //  console.log(event)
      //  console.log(email, 'email')
        if (email === '' ||password === '') {
            setError(true)
        }
        if (email === '') {
            setEmailError('udfyld venligst email')
        }
        if (password === '') {
            setPasswordError('udfyld venligst adgangskode')
        }

        if (email && email.length && email.match(isValidEmail) && password.length) {
           
            setLoading(true)
            // if email and password is correct and founds in the system - go to profile page
            fetch(`http://dev.ebillet.dk/systemnative/customer.asmx/Login?Email=${email}&Password=${password}`, {
                method: "GET",
            })
                .then((res) => res.json())
                .then(result => {
                    setLoading(false)
                  //  console.log(result, 'result')
                    if (result.result === 1) {
                        
                        history.push('/profile', {
                            login_info: result.login,
                            transaction: result.transactionsPrYear[0],
                            newsgroup: result.Newsgroups,
                            reservations: result.Reservations,
                            key:result.key

                        })
                    }
                    else {
                        setError(true)
                        setEmailError(result.Message)
                    }
                })


         //   history.push('/profile')
        }
        else if (email.length && !email.match(isValidEmail)){
            setShowNoValidEmail(true);
            setEmailError('email er ikke gyldig')
        }
    };

    const emailChanged = (e) => {
       
        setEmail(e.target.value)
        setEmailError('')
        validateEmail(e)
        setError(false)
    }
    const passwordChanged = (e) => {
        setPassword(e.target.value)
        setPasswordError('')
        setError(false)

    }

    function handleRememberChange() {
        setRememberme((current => !current))
    }
    function passwordForgotten() {
        history.push('/resetpassword')
        //if (email === '') {
        //    setError(true)
        //    setEmailError('udfyld venligst email')
        //}
        //if (email && email.length && email.match(isValidEmail)) {
        //    console.log('open change password div')
            
          
        //}
    }

   


    function handleCreateProfile() {
        history.push('/createaccount')
    }

    useEffect(() => {
       
        if (rememberme === true) {
            sessionStorage.setItem('email', email)
            sessionStorage.setItem('pw', password)

        }
        else if (rememberme === false) {  
                sessionStorage.removeItem('email', email)
            sessionStorage.removeItem('pw', password)
        }
    }, [rememberme])
  
    return (
        <>
            {loading === true ? <div className='spinner' style={{ borderRightColor: 'rgba(157, 45, 38, 1)' }}></div>
                :  
              <div className='login' style={{padding: '20px 20px 60px 20px'} } >
                 <p className='profile'>Din profil</p>
                 <p className='emailtext'>Indtast brugeroplysninger</p>
           
                <label className='email-label'>Email</label>
                <input className='email-input' placeholder='Indtast email' value={email} onChange={(e) => emailChanged(e)} />
                <label>Adgangskode</label>
                <input className='password' type='password' value={password} placeholder='Indtast adgangskode' onChange={(e) => passwordChanged(e)} ></input>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ position: 'relative' }} onClick={() => handleRememberChange() }>
                        {
                            rememberme === true ? 
                             <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                               <rect x="1" y="1" width="22" height="22" rx="3" stroke="white" stroke-width="2" />
                               <path d="M7 11L11 16L17.5 7" stroke="white" stroke-width="2" stroke-linecap="round" />
                            </svg>
                                : 
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                               <rect x="1" y="1" width="22" height="22" rx="3" stroke="white" stroke-width="2" />
                            </svg>

                        }
                        <label style={{ position: 'absolute', left: '35px', width:'100px',fontWeight:400 }}>Husk mig</label>
                    </div>
                    
                        <button type="submit" className='login-btn' onClick={ handleSubmit}>Log ind</button>
                       
                    
                </div>
                <div className='btns-container' >
                        <button onClick={passwordForgotten }>Glemt adgangskode?</button>
                       <button  onClick={handleCreateProfile }>Opret profil</button>
                </div>
           
            {error === true ?
                <div className='error-div'>
                    {notFoundError}
                    {emailError && <span>{emailError}</span>}
                    {passwordError && <span>{passwordError}</span>}
                </div> : null}
            </div>

            
            } 
          
        </>
    )
}

export default Login